import { render, staticRenderFns } from "./ekk_fliter.vue?vue&type=template&id=124dad98"
import script from "./ekk_fliter.vue?vue&type=script&lang=js"
export * from "./ekk_fliter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports